import { Injectable } from "@angular/core"
import { BehaviorSubject, Subject } from "rxjs"

@Injectable()
export class ConfirmDialogService {
    public confirm = new Subject<any>();
    public observer: any = this.confirm.asObservable();
    public data: any = {};

    show(args: any) {
        const loaderEl = document.getElementById("confirm-dialog-static-backdrop");
        loaderEl.setAttribute("style", "display: block; z-index: 4000");
        loaderEl.classList.add("show");
        this.confirm.next(args);
    }

    hide() {
        const loaderEl = document.getElementById("confirm-dialog-static-backdrop");
        loaderEl.setAttribute("style", "display: none;");
        loaderEl.classList.remove("show");
    }

}